export function MicDisabledIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="currentColor"
      className={className}
    >
      <path
        fillRule="evenodd"
        d="M2.975 8.002a.5.5 0 0 1 .547.449 4.5 4.5 0 0 0 8.956 0 .5.5 0 1 1 .995.098A5.502 5.502 0 0 1 8.5 13.478V15h2a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1h2v-1.522a5.502 5.502 0 0 1-4.973-4.929.5.5 0 0 1 .448-.547z"
        clipRule="evenodd"
      ></path>
      <path d="M5 3v5a3 3 0 0 0 4.785 2.417l.915.915A4.5 4.5 0 0 1 3.522 8.45a.5.5 0 1 1 .994-.102A3.5 3.5 0 0 0 11 8V3a3 3 0 1 0-6 0z"></path>
      <path d="m12.646 14.354-10-10 .708-.708 10 10-.708.708z"></path>
    </svg>
  );
}
